export default {"src":"/_next/static/media/icon-individuals.5547b737.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};